"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalGeneratePINForUser = exports.TerminalActionCheckOut = exports.TerminalActionCheckIn = exports.TerminalUserLogin = exports.TerminalLogout = exports.TerminalData = exports.TerminalLogin = void 0;
const terminalLogin_gql_1 = __importDefault(require("./terminalLogin.gql"));
exports.TerminalLogin = terminalLogin_gql_1.default;
const terminalData_gql_1 = __importDefault(require("./terminalData.gql"));
exports.TerminalData = terminalData_gql_1.default;
const terminalLogout_gql_1 = __importDefault(require("./terminalLogout.gql"));
exports.TerminalLogout = terminalLogout_gql_1.default;
const terminalUserLogin_gql_1 = __importDefault(require("./terminalUserLogin.gql"));
exports.TerminalUserLogin = terminalUserLogin_gql_1.default;
const terminalActionCheckin_gql_1 = __importDefault(require("./terminalActionCheckin.gql"));
exports.TerminalActionCheckIn = terminalActionCheckin_gql_1.default;
const terminalActionCheckOut_gql_1 = __importDefault(require("./terminalActionCheckOut.gql"));
exports.TerminalActionCheckOut = terminalActionCheckOut_gql_1.default;
const terminalGeneratePINForUser_gql_1 = __importDefault(require("./terminalGeneratePINForUser.gql"));
exports.TerminalGeneratePINForUser = terminalGeneratePINForUser_gql_1.default;
